import React from "react";
import DummyComponent from "../components/dummycomponent";
import UploadFileComponent from "../components/uploadfile";
import UploadFileV2Component from "../components/uploadFileV2";
import UberConfirmDetailComponent from "../components/uberconfirmdetailcomponent";
import SfxConfirmDetailComponent from "../components/sfxconfirmdetailcomponent";
import SfxAppLinkComponent from "../components/sfxapplinkcomponent";
import DunzoAppLinkComponent from "../components/dunzoapplinkcomponent";
import DunzoConfirmDetailComponent from "../components/dunzoconfirmdetailcomponent";
import CallButtonComponent from "../components/callbuttoncomponent";
import documentValidationConfig from "../config/documentValidationConfig";
import { isAlphaNum } from "../../lib/utils";

//Generic Step builder function, attach validator is not supported
const genericStepBuilder = (id, trigger, message, user, component, options, isEnd, asMessage, waitAction, shouldDisplay) => {
    let step = {};
    if (id) step['id'] = id;
    if (message) step['message'] = message;
    if (user) step['user'] = user;
    if (trigger) step['trigger'] = trigger;
    if (component) step['component'] = component;
    if (options) step['options'] = options;
    if (asMessage) step['asMessage'] = asMessage;
    if (waitAction) step['waitAction'] = waitAction;
    if (isEnd) step['end'] = isEnd;
    if (shouldDisplay) step['shouldDisplay'] = shouldDisplay;
    return step;
};

const attachMobileNoValidator = (data) => {
    data["validator"] = function (value) {
        if (isNaN(value)) {
            return 'value must be a number';
        } else if (value.length !== 10) {
            return 'Please enter a valid number';
        } else if (value === '') {
            return "Please enter a phone number"
        }
        return true;
    };
    return data;
};

const attachAlphaNumValidator = (data) => {
    data["validator"] = function (value) {
        if (!isAlphaNum(value)) {
            return 'Enter a valid input';
        } else if (value === '') {
            return "Please enter an input"
        }
        return true;
    };
    return data;
};

const attachDocumentValidator = (data) => {
    const documentName = data['validation_type'].slice('document_'.length, data['validation_type'].length)
    const documentConfig = documentValidationConfig[documentName]

    data["validator"] = function (value) {
        if (documentConfig) {
            if (!documentConfig.regex.test(value) || value.length > documentConfig.max_length || value.trim() === '') {
                return documentConfig.error_message
            }
        }
        return true;
    };
    return data;
};


const submitApiCall = (stepName, stepIdentifier, nextStepName, stepType, chatFormIdentifier, type, identifier, identifierType) => {
    return genericStepBuilder(
        stepName,
        nextStepName,
        null,
        null,
        <DummyComponent name={stepIdentifier} stepType={stepType} chatFormIdentifier={chatFormIdentifier} identifier={identifier} identifierType={identifierType} type={type} />,
        null, null,
        null,
        null,
        false
    )
};

const handleFileUpload = (stepName, stepIdentifier, nextStepName, chatFormIdentifier, type, identifier, identifierType) => {
    return genericStepBuilder(
        stepName,
        nextStepName,
        null,
        null,
        window.app ? <UploadFileV2Component name={stepIdentifier} chatFormIdentifier={chatFormIdentifier} identifier={identifier}
            identifierType={identifierType} type={type} /> : <UploadFileComponent name={stepIdentifier} chatFormIdentifier={chatFormIdentifier} identifier={identifier}
                identifierType={identifierType} type={type} />,
        null,
        null,
        true,
        true);
};


const uberConfirmDetailComponent = (stepName, stepIdentifier, nextStepName, chatFormIdentifier, type, identifier, identifierType, candidateName, mobileNo, city) => {
    return genericStepBuilder(
        stepName,
        nextStepName,
        null,
        null,
        <UberConfirmDetailComponent name={stepIdentifier} chatFormIdentifier={chatFormIdentifier} identifier={identifier}
            identifierType={identifierType} type={type} city={city} candidateName={candidateName}
            mobileNo={mobileNo} />,
        null,
        null,
        true,
        true);
};

const sfxConfirmDetailComponent = (stepName, stepIdentifier, nextStepName, chatFormIdentifier, type, identifier, identifierType, candidateName, mobileNo, city, location) => {
    return genericStepBuilder(
        stepName,
        nextStepName,
        null,
        null,
        <SfxConfirmDetailComponent name={stepIdentifier} chatFormIdentifier={chatFormIdentifier} identifier={identifier}
            identifierType={identifierType} type={type} city={city} candidateName={candidateName}
            mobileNo={mobileNo} location={location} />,
        null,
        null,
        true,
        true);
};


const dunzoConfirmDetailComponent = (stepName, stepIdentifier, nextStepName, chatFormIdentifier, type, identifier, identifierType, candidateName, mobileNo, city, location) => {
    return genericStepBuilder(
        stepName,
        nextStepName,
        null,
        null,
        <DunzoConfirmDetailComponent name={stepIdentifier} chatFormIdentifier={chatFormIdentifier} identifier={identifier}
            identifierType={identifierType} type={type} city={city} candidateName={candidateName}
            mobileNo={mobileNo} location={location} />,
        null,
        null,
        true,
        true);
};


const sfxAppLinkComponent = (stepName, chatFormIdentifier) => {
    return genericStepBuilder(
        stepName,
        null,
        null,
        null,
        <SfxAppLinkComponent chatFormIdentifier={chatFormIdentifier} />,
        null,
        true,
        true,
        false
    );
};

const dunzoAppLinkComponent = (stepName) => {
    return genericStepBuilder(
        stepName,
        null,
        null,
        null,
        <DunzoAppLinkComponent />,
        null,
        true,
        true,
        false
    );
};

const callButtonComponent = (stepName, stepIdentifier, nextStepName, chatFormIdentifier, type, identifier,
    identifierType, phoneNumber, isEnd) => {
    return genericStepBuilder(
        stepName,
        nextStepName,
        null,
        null,
        <CallButtonComponent phoneNumber={phoneNumber} />,
        null,
        isEnd,
        true,
        false
    );
};


export default {
    attachMobileNoValidator,
    attachDocumentValidator,
    submitApiCall,
    handleFileUpload,
    uberConfirmDetailComponent,
    sfxConfirmDetailComponent,
    sfxAppLinkComponent,
    dunzoAppLinkComponent,
    dunzoConfirmDetailComponent,
    callButtonComponent,
    attachAlphaNumValidator,
}
